<template>
  <div class="mains">
    <div class="campus">
      教务管理
      <span>></span>
      <router-link to="classs">班级管理</router-link>
      <span>></span>
      <router-link to>{{ banji_id.name }}</router-link>
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">班级学员</div>
          <el-button type="primary" class="buttons" @click="addstudentlist">
            <span>+</span>
            添加学员
          </el-button>
          <!--<el-button type="primary" class="buttons">导出学员</el-button>
          <el-button type="primary" class="buttons">导入学员</el-button>-->
          <!-- <el-button type="primary" class="buttons" @click="dels(tabchecked)">批量删除</el-button> -->
          <div class="sousuo">
            <span>学员姓名：</span>
            <el-input
              v-model="orgname"
              @keyup.13.native="selectStudentByClassPage"
              placeholder="请输入学员姓名"
            ></el-input>
            <el-button
              type="primary"
              class="buttons"
              @click="selectStudentByClassPage()"
              >查 询</el-button
            >
          </div>

          <div class="zsbg zsbg_2">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              @select="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="57"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="name" label="学员姓名"></el-table-column>
              <el-table-column
                prop="showCreateTime"
                label="报名时间"
              ></el-table-column>
              <el-table-column
                prop="acount_status"
                label="账号状态"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <el-button
                    type="text"
                    class="caozuo"
                    @click="removeStudentClass(stData.row.id)"
                    >移出</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">班级员工</div>
          <el-button type="primary" class="buttons" @click="addemplist">
            <span>+</span>
            添加员工
          </el-button>
          <!--<el-button type="primary" class="buttons">导出学员</el-button>
          <el-button type="primary" class="buttons">导入学员</el-button>-->
          <!-- <el-button type="primary" class="buttons" @click="dels(tabchecked)">批量删除</el-button> -->
          <div class="sousuo">
            <span>员工姓名：</span>
            <el-input
              v-model="orgnames"
              @keyup.13.native="selectTeacherByClassidPage"
              placeholder="请输入员工姓名或员工账号"
            ></el-input>
            <el-button
              type="primary"
              class="buttons"
              @click="selectTeacherByClassidPage()"
              >查 询</el-button
            >
          </div>

          <div class="zsbg zsbg_2">
            <el-table
              :data="tableDatas"
              border
              style="width: 100%"
              @select="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="57"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="username"
                label="员工账户"
                max-width="360"
              ></el-table-column>
              <el-table-column prop="name" label="员工姓名"></el-table-column>
              <el-table-column
                label="账号状态"
                prop="accountstatusName"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <el-button
                    type="text"
                    class="caozuo"
                    @click="removeTeacherClass(stData.row.id)"
                    >移出</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            @size-change="handleSizeChanges"
            @current-change="handleCurrentChanges"
            :current-page="currentPages"
            :page-sizes="[5, 10, 30, 50, 100]"
            :page-size="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totals"
          ></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'student',
  data () {
    return {
      orgname: '',
      orgnames: '',
      tableData: [],
      tableDatas: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 5,
      pageSizes: 5,
      currentPage: 1,
      currentPages: 1,
      total: 0,
      totals: 0,
      banji_id: {}
    }
  },
  created () {
    if (!this.$store.state.classid) {
      this.$router.push({ name: 'classs' })
      return this.$message.error('您当前的班级数据获取失败！')
    }
    this.banji_id = this.$store.state.classid

    this.selectStudentByClassPage()
    this.selectTeacherByClassidPage()
  },
  destroyed () {
    localStorage.removeItem('classid')
  },
  methods: {
    // 获得学员列表
    selectStudentByClassPage () {
      // console.log(this.orgnames)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/student/selectStudentByClassPage',
        method: 'POST',
        data: {
          org_id: orgid,
          classid: this.banji_id.id,
          name: this.orgname,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
          var data = result.data.data
          this.tableData = data
          if (data === undefined || data === null) {
            this.total = 0
          } else {
            this.total = result.data.size
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得学员列表失败：' + err)
        })
    },

    // 添加学员
    addstudentlist () {
      this.$store.commit('banji_tian', this.banji_id)
      this.$router.push({ name: 'addstudentlist' })
    },

    // 移出学员
    removeStudentClass (id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/edu/student/removeStudentClass',
        method: 'POST',
        data: {
          id: id,
          classid: this.banji_id.id
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
          this.selectStudentByClassPage()
          return this.$message.success(result.data.message)
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得学员列表失败：' + err)
        })
    },

    // 添加员工
    addemplist () {
      this.$store.commit('banji_tian1', this.banji_id)
      this.$router.push({ name: 'addemplist' })
    },

    // 移出员工
    removeTeacherClass (id) {
      // console.log(id)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/edu/teacher/removeTeacherClass',
        method: 'POST',
        data: {
          id: id,
          classid: this.banji_id.id
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
          this.selectTeacherByClassidPage()
          return this.$message.success(result.data.message)
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得学员列表失败：' + err)
        })
    },

    // 获得员工列表
    selectTeacherByClassidPage () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/teacher/selectTeacherByClassidPage',
        method: 'POST',
        data: {
          orgid: orgid,
          classid: this.banji_id.id,
          name: this.orgnames,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message)
          }
          var data = result.data.data
          this.tableDatas = data
          if (data === undefined || data === null) {
            this.totals = 0
          } else {
            this.totals = result.data.size
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得员工列表失败：' + err)
        })
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.page = 1
      this.currentPage = 1
      this.selectStudentByClassPage()
    },
    handleCurrentChange (val) {
      this.page = val
      this.selectStudentByClassPage()
    },
    handleSizeChanges (val) {
      this.pageSizes = val
      this.page = 1
      this.currentPages = 1
      this.selectTeacherByClassidPage()
    },
    handleCurrentChanges (val) {
      this.page = val
      this.selectTeacherByClassidPage()
    }
  }
}
</script>

<style lang="less">
.mains {
  .campus {
    // width: 28px;
    // height: 20px;
    font-family: PingFang SC;
    font-size: 14px;
    color: #666666ff;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 10px;
    span {
      margin: 0 10px 0 8px;
    }
  }
  .zt1 {
    color: #000 !important;
  }
  .xiaoqu {
    margin-bottom: 20px;
  }
  .xiaoqu .grid-content .el-dialog .form_1_1 .xingbie {
    position: absolute;
    top: 6.85vw;
    right: 3.22917vw;
  }
  .xiaoqu
    .grid-content
    .el-dialog
    .form_1_1
    .el-form-item
    .student_dropdown
    .el-button--primary {
    width: 7.20833vw;
  }
  .xiaoqu .grid-content .el-dialog .form_1_1 .el-form-item .el-input__inner {
    color: #000;
  }
  .xiaoqu .grid-content .zsbg_2 .el-table {
    .el-table_1_column_1 {
      padding-left: 2% !important;
    }
    .el-table_1_column_2 {
      padding-left: 5% !important;
    }
    .el-table_1_column_3 {
      text-align: center;
      padding-left: 0 !important;
    }
    .el-table_2_column_6 {
      text-align: left;
      padding-left: 2% !important;
    }
    .el-table_2_column_7 {
      text-align: left;
      padding-left: 5% !important;
    }
    .el-table_2_column_8 {
      text-align: left;
      padding-left: 3% !important;
    }
    .el-table_2_column_9 {
      text-align: center;
      padding-left: 0 !important;
    }
    .el-table_2_column_10 {
      text-align: center;
      padding-left: 0 !important;
    }
  }
  .lianxi {
    color: #00a6e6;
  }

  .xzbz {
    i {
      position: fixed !important;
      right: 320px;
      top: 147px;
    }
  }
  .chushen {
    .el-icon-date:before {
      content: "";
    }
  }
}
.student_dropdown .el-dropdown-menu__item {
  width: 6.375vw;
}
.student_zhuantai {
  position: relative;
  // top: 10.83333vw !important;
  left: 1104px !important;
}
.student_zhuantai1 {
  position: relative;
  // top: 25vw !important;
  left: 67.96875vw !important;
}
</style>
